import {createContext, useContext} from "react";
export type AssetTarget = "background" | "image" | "logo" | "speaker-1" | "speaker-2" | `ls-speaker-${1 | 2 | 3 | 4 | 5 | 6}` | "overlay" | "custom-qr-1" | "custom-qr-2" | "custom-qr-3";
export type BannerRuntimeValue = {
  upload: (target: AssetTarget, file: File) => Promise<boolean>;
  cancelUpload: (target: AssetTarget) => void;
  selectBackground: (option: string) => Promise<boolean>;
  layoutOption: number | null;
  backgroundOption: string | null;
  pending: number;
  error: string;
};
export const BannerRuntime = createContext<BannerRuntimeValue | null>(null);
export function useBannerRuntime(): BannerRuntimeValue {
  const value = useContext(BannerRuntime);
  if (!value) throw new Error("BannerRuntime provider missing");
  return value;
}
